const initialState = {
  cities: [],
  loading: false,
  error: null,
  citiesNumber: 0,
};

const citiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_CITIES_LOADING":
      return {
        ...state,
        loading: true,
      };
    case "GET_CITIES_SUCCESS":
      return {
        ...state,
        cities: action.payload.data,
        loading: false,
        citiesNumber: action.payload.meta.pagination.total,
      };

    case "REFETCH_CITY_SUCCESS":
      return {
        ...state,
        cities: state.cities.map((city) =>
          city.id === action.payload.id ? action.payload : city
        ),
      };
    case "GET_CITIES_FAILURE":
      return initialState;
    default:
      return state;
  }
};
export default citiesReducer;
